import React from 'react'
import Item from './Item'
import Loader from './Loader'
import { Box } from 'stylist'

const ListBox = ({ children }) => <Box dividers>{children}</Box>

ListBox.Item = Item
ListBox.Loader = Loader

export default ListBox



// WEBPACK FOOTER //
// ./src/components/ListBox/index.js